import { motion } from "framer-motion";
import { AGENTS } from "@/lib/agents";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";

const routes = { ceo: "/dashboard", marketer: "/marketer", sales: "/sales", accountant: "/accountant" };

export default function Crew() {
  return (
    <div className="p-8 pb-16">
      <motion.h1 initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="font-display text-4xl sm:text-5xl font-bold mb-2">
        <span className="chrome-text">The Crew</span>
      </motion.h1>
      <p className="text-white/70 mb-10">Three AI employees + your CEO co-founder. Each one runs their own workspace.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {Object.values(AGENTS).map((a, i) => (
          <motion.div
            key={a.id}
            initial={{ opacity: 0, y: 30, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            whileHover={{ y: -6 }}
            transition={{ delay: i * 0.08, type: "spring", bounce: 0.4 }}
            className="glass rounded-[2rem] p-8 relative overflow-hidden"
            data-testid={`crew-card-${a.id}`}
          >
            <div className="absolute -top-6 -right-6 w-40 h-40 blur-3xl opacity-40" style={{ background: a.gradient }} />
            <div className="flex items-start gap-5 relative">
              <motion.div
                animate={{ y: [0, -8, 0] }}
                transition={{ duration: 3.5, repeat: Infinity, ease: "easeInOut", delay: i * 0.4 }}
                className="w-24 h-24 slime-blob overflow-hidden flex-shrink-0"
                style={{ background: a.gradient, boxShadow: `0 0 40px ${a.color}55` }}
              >
                <img src={a.avatar} alt={a.name} className="w-full h-full object-cover mix-blend-luminosity" />
              </motion.div>
              <div className="flex-1">
                <div className="font-mono text-[10px] uppercase tracking-widest" style={{ color: a.color }}>{a.role}</div>
                <div className="font-display text-3xl font-bold mt-1">{a.name}</div>
                <p className="text-white/70 mt-2">{a.tagline}</p>
                <Link
                  to={routes[a.id]}
                  data-testid={`crew-open-${a.id}`}
                  className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-full font-bold text-slate-900 hover:opacity-90"
                  style={{ background: a.gradient }}
                >
                  <MessageCircle className="w-4 h-4" /> Open workspace
                </Link>
              </div>
            </div>

            <div className="mt-6 grid grid-cols-3 gap-2">
              {[["Drafts", "This week"], ["Approved", "0"], ["Queued", "0"]].map(([k, v]) => (
                <div key={k} className="bg-white/5 rounded-xl p-3 border border-white/10 text-center">
                  <div className="font-mono text-[10px] uppercase tracking-widest text-white/50">{k}</div>
                  <div className="font-display text-lg font-bold">{v}</div>
                </div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
